import { Button } from "react-bootstrap";
import TextTruncate from "../../../../../../components/helpers/TextTruncate";

const buttonActionStyle = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

export const vehicleInsuranceInfo = {
  storedPlace: {
    label: "Tempat Simpan",
  },
  officerName: {
    label: "Disimpan Oleh",
  },
  stnkPicture: {
    label: "Foto STNK",
  },
  bpkbPicture: {
    label: "Foto BPKB",
  },
  vehicleNumber: {
    label: "No. Polisi / No. Registrasi",
  },
  bpkbNumber: {
    label: "No. BPKB",
  },
  stnkOwnerName: {
    label: "Nama Sesuai STNK",
  },
  stnkOwnerAddress: {
    label: "Alamat Sesuai STNK",
  },
  type: {
    label: "Jenis",
  },
  brandName: {
    label: "Merk",
  },
  typeName: {
    label: "Tipe",
  },
  modelName: {
    label: "Model",
  },
  year: {
    label: "Tahun",
  },
  transmission: {
    label: "Transmisi",
  },
  rangkaNumber: {
    label: "No. Rangka",
  },
  machineNumber: {
    label: "No. Mesin",
  },
  colour: {
    label: "Warna",
  },
};

export const bpkbInsuranceInfo = {
  type: {
    label: "Jenis",
  },
  stnkPicture: {
    label: "Foto STNK",
  },
  vehicleNumber: {
    label: "No. Polisi / No. Registrasi",
  },
  bpkbNumber: {
    label: "No. BPKB",
  },
  brandName: {
    label: "Merk",
  },
  typeName: {
    label: "Tipe",
  },
  modelName: {
    label: "Model",
  },
  year: {
    label: "Tahun",
  },
  transmission: {
    label: "Transmisi",
  },
  rangkaNumber: {
    label: "No. Rangka",
  },
  machineNumber: {
    label: "No. Mesin",
  },
};

export const smartphoneInsuranceInfo = {
  storedPlace: {
    label: "Tempat Tersimpan",
  },
  officerName: {
    label: "Disimpan Oleh",
  },
  brandName: {
    label: "Merk",
  },
  modelName: {
    label: "Model",
  },
  imeiNumber: {
    label: "No. IMEI",
  },
};

export const exclusiveInsuranceInfo = {
  storedPlace: {
    label: "Tempat Tersimpan",
  },
  officerName: {
    label: "Disimpan Oleh",
  },
};

export const bpkbValuationInfo = {
  stnkCondition: {
    label: "STNK Sesuai?",
  },
  vehicleCondition: {
    label: "Fisik Kendaraan Sesuai?",
  },
};

export const smartphoneValuationInfo = {
  finalEstimatedPrice: {
    label: "Harga Taksiran Akhir",
  },
  frontCondition: {
    label: "Kondisi Fisik Bagian Depan",
  },
  backCondition: {
    label: "Kondisi Fisik Bagian Belakang",
  },
  screenCondition: {
    label: "Kondisi Layar",
  },
  functionalTest: {
    label: "Tes Fungsional",
  },
};

export const exclusiveValuationInfo = {
  finalEstimatedPrice: {
    label: "Harga Taksiran Akhir",
  },
  name: {
    label: "Nama Barang",
  },
  detail: {
    label: "Detail Barang",
  },
  condition: {
    label: "Kondisi Barang",
  },
  notes: {
    label: "Keterangan Tambahan",
  },
};

export const summaryTableColumn = (copyToClipbord, handleDetail) => {
  return [
    {
      dataIndex: "transactionID",
      key: "transactionID",
      backend_key: "transaction_id",
      title: "ID Transaksi",
      sorter: true,
    },
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "10%",
    },

    {
      dataIndex: "transactionType",
      key: "transactionType",
      title: "Jenis Transaksi",
    },
    {
      dataIndex: "transactionMethod",
      key: "transactionMethod",
      title: "Metode Transaksi",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah",
    },
    {
      dataIndex: "transactionProof",
      key: "transactionProof",
      title: "Bukti Transaksi",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
    },
    {
      dataIndex: "voucher",
      key: "voucher",
      title: "Voucher",
      // width: "200px",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={buttonActionStyle}>
          <Button
            variant="primary"
            className="btn-action btn-detail"
            onClick={() => handleDetail(record)}
          >
            Detail
          </Button>
        </div>
      ),
    },
  ];
};
